import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginResponseInterface } from '../models/login-response.interface';
import { ApiService } from '../../shared/services/api.service';
import { LoginRequestInterface } from '../models/login-request.interface';

@Injectable()
export class LoginService {

  constructor(private apiService: ApiService) {}

  /**
   * Get customer token
   * @param data
   */
  getToken(data: LoginRequestInterface): Observable<LoginResponseInterface|{customerId: string}> {
    return this.apiService.post<LoginResponseInterface|{customerId: string}>('login', data);
  }

  /**
   * Refresh customer token
   * @param data
   */
  refreshToken(): Observable<LoginResponseInterface> {
    return this.apiService.post<LoginResponseInterface>('refresh-token', {});
  }

  /**
   * Forgot password
   * @param login
   * @param phoneNumber
   */
  forgotPassword(login: string, phoneNumber?: string): Observable<any> {
    return this.apiService.post<any>('vitrine/customer/forgot-password', {login: login.replace(/ /g, ''), phoneNumber});
  }

  /**
   * Reset password
   * @param newPassword
   * @param token
   * @param captchaKey
   * @param captchaToken
   */
  resetPassword(newPassword: string, token: string, captchaKey: string, captchaToken: string): Observable<any> {
    return this.apiService.post<any>('reset-password', {newPassword, token, captchaKey, captchaToken});
  }

  /**
   * Reset login sms
   * @param email
   * @param phoneNumber
   * @param captchaKey
   * @param captchaToken
   */
  resetLoginSms(email: string, phoneNumber: string, captchaKey: string, captchaToken: string): Observable<any> {
    return this.apiService.post<any>('vitrine/customer/reset-login/sms', {email: email.replace(/ /g, ''), phoneNumber, captchaKey, captchaToken});
  }

  /**
   * Reset login
   * @param email
   * @param phoneNumber
   * @param captchaKey
   * @param captchaToken
   * @param code
   * @param billId
   */
  resetLogin(email: string, phoneNumber: string, captchaKey: string, captchaToken: string, code?: string, billId?: number, ): Observable<any> {
    return this.apiService.post<any>('vitrine/customer/reset-login', {email: email.replace(/ /g, ''), phoneNumber, code, billId, captchaKey, captchaToken});
  }

  /**
   * Generate password for first connexion
   */
  generatePassword(phoneNumber: string): Observable<any> {
    return this.apiService.post('vitrine/generate/password/first/connexion', {phoneNumber});
  }

  /**
   * Check reset password token
   */
  checkToken(token: string): Observable<any> {
    return this.apiService.get('vitrine/check/reset-password/token/' + token);
  }

  /**
   * Logout
   */
  logout(): Observable<any> {
    return this.apiService.get<any>('logout');
  }
}
